import { Button } from "@community-project-org/ui";
import { Minus, Plus } from "lucide-react";
import type { JSX } from "react";

interface StepperProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  /** Wofür gezählt wird, für Screenreader: „Anzahl“, „Nächte“. */
  label: string;
}

/**
 * Plus und Minus um eine Zahl — Tickets, Stunden, Nächte. Die Zahl steht in Mono,
 * damit sie beim Zählen nicht springt; beide Schaltflächen sind volle Touch-Ziele.
 */
export function Stepper({ value, min, max, onChange, label }: StepperProps): JSX.Element {
  return (
    <div className="flex items-center gap-2" role="group" aria-label={label}>
      <Button variant="secondary" aria-label={`${label} verringern`} disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))}>
        <Minus size={16} aria-hidden="true" />
      </Button>
      <span className="num w-8 text-center text-[17px] font-extrabold text-ink" aria-live="polite">
        {value}
      </span>
      <Button variant="secondary" aria-label={`${label} erhöhen`} disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))}>
        <Plus size={16} aria-hidden="true" />
      </Button>
    </div>
  );
}
